import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Results } from './components/Results';
import { Method } from './components/Method';
import { Deliverables } from './components/Deliverables';
import { Bonuses } from './components/Bonuses';
import { Experience } from './components/Experience';
import { Story } from './components/Story';
import { ForWhom } from './components/ForWhom';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-ink text-ivory font-sans selection:bg-gold selection:text-ink" data-id="element-0" data-mp="28te3lff7pdo5">
      <MetaPixel data-id="element-1" data-mp="23u9q4cl98ts0" />
      <main data-id="element-2" data-mp="23ut97wmn5o7m">
        <Hero data-id="element-3" data-mp="23t8iki3g6pf1" />
        <PainPoints data-id="element-4" data-mp="3ijxpcqos80jw" />
        <Results data-id="element-5" data-mp="3ikh829m9asyz" />
        <Method data-id="element-6" data-mp="3iiweonbohg2p" />
        <Deliverables data-id="element-7" data-mp="3ijfvu1ti80fo" />
        <Bonuses data-id="element-8" data-mp="3ihv1ac76whht" />
        <Experience data-id="element-9" data-mp="3mlj8uuvtnd32" />
        <Story data-id="element-10" data-mp="3mkrd9k285fcs" />
        <ForWhom data-id="element-11" data-mp="3mkhou0wtvg97" />
        <Pricing data-id="element-12" data-mp="3mjzpuwis6nxl" />
        <Testimonials data-id="element-13" data-mp="3mjgczu7zmpqf" />
        <FAQ data-id="element-14" data-mp="3rcj6k2crlz6m" />
        <FinalCTA data-id="element-15" data-mp="3rbrcwx2qabiz" />
      </main>
      <Footer data-id="element-16" data-mp="3rcsyhvhdegey" />
      <WhatsAppFloat data-id="element-17" data-mp="3rd17vdeab3le" />
    </div>;
}